module.exports = __webpack_public_path__ + "static/media/015-Aktivierung_ID_10.4ed196ac.mp3";